// GENERATED by scripts/gen-icons.mjs — do not edit.
// Run `npm run gen:icons` after bumping lucide-react.

/**
 * Lucide's 258 deprecated slugs, mapped to the canonical slug that
 * replaced them (`alert-circle` → `circle-alert`).
 *
 * Kept so a name stored in a database years ago keeps rendering after a lucide
 * bump renames it. Resolution goes through here first, so an alias loads the
 * shard of its *canonical* slug.
 */
export const iconAliases: Record<string, string> = {
    "activity-square": "square-activity",
    "alarm-check": "alarm-clock-check",
    "alarm-minus": "alarm-clock-minus",
    "alarm-plus": "alarm-clock-plus",
    "alert-circle": "circle-alert",
    "alert-octagon": "octagon-alert",
    "alert-triangle": "triangle-alert",
    "align-center": "text-align-center",
    "align-justify": "text-align-justify",
    "align-left": "text-align-start",
    "align-right": "text-align-end",
    angry: "face-angry",
    annoyed: "face-expressionless",
    "area-chart": "chart-area",
    "arrow-down-01": "arrow-down-0-1",
    "arrow-down-10": "arrow-down-1-0",
    "arrow-down-az": "arrow-down-a-z",
    "arrow-down-circle": "circle-arrow-down",
    "arrow-down-left-from-circle": "circle-arrow-out-down-left",
    "arrow-down-left-from-square": "square-arrow-out-down-left",
    "arrow-down-left-square": "square-arrow-down-left",
    "arrow-down-right-from-circle": "circle-arrow-out-down-right",
    "arrow-down-right-from-square": "square-arrow-out-down-right",
    "arrow-down-right-square": "square-arrow-down-right",
    "arrow-down-square": "square-arrow-down",
    "arrow-down-za": "arrow-down-z-a",
    "arrow-left-circle": "circle-arrow-left",
    "arrow-left-square": "square-arrow-left",
    "arrow-right-circle": "circle-arrow-right",
    "arrow-right-square": "square-arrow-right",
    "arrow-up-01": "arrow-up-0-1",
    "arrow-up-10": "arrow-up-1-0",
    "arrow-up-az": "arrow-up-a-z",
    "arrow-up-circle": "circle-arrow-up",
    "arrow-up-left-from-circle": "circle-arrow-out-up-left",
    "arrow-up-left-from-square": "square-arrow-out-up-left",
    "arrow-up-left-square": "square-arrow-up-left",
    "arrow-up-right-from-circle": "circle-arrow-out-up-right",
    "arrow-up-right-from-square": "square-arrow-out-up-right",
    "arrow-up-right-square": "square-arrow-up-right",
    "arrow-up-square": "square-arrow-up",
    "arrow-up-za": "arrow-up-z-a",
    "asterisk-square": "square-asterisk",
    "axis-3-d": "axis-3d",
    "badge-help": "badge-question-mark",
    "bar-chart": "chart-no-axes-column-increasing",
    "bar-chart-2": "chart-no-axes-column",
    "bar-chart-3": "chart-column",
    "bar-chart-4": "chart-column-increasing",
    "bar-chart-big": "chart-column-big",
    "bar-chart-horizontal": "chart-bar",
    "bar-chart-horizontal-big": "chart-bar-big",
    "between-horizonal-end": "between-horizontal-end",
    "between-horizonal-start": "between-horizontal-start",
    "book-template": "book-dashed",
    "box-select": "square-dashed",
    "candlestick-chart": "chart-candlestick",
    "check-circle": "circle-check-big",
    "check-circle-2": "circle-check",
    "check-square": "square-check-big",
    "check-square-2": "square-check",
    "chevron-down-circle": "circle-chevron-down",
    "chevron-down-square": "square-chevron-down",
    "chevron-left-circle": "circle-chevron-left",
    "chevron-left-square": "square-chevron-left",
    "chevron-right-circle": "circle-chevron-right",
    "chevron-right-square": "square-chevron-right",
    "chevron-up-circle": "circle-chevron-up",
    "chevron-up-square": "square-chevron-up",
    "circle-help": "circle-question-mark",
    "circle-slashed": "circle-slash-2",
    "clipboard-edit": "clipboard-pen",
    "clipboard-signature": "clipboard-pen-line",
    "code-2": "code-xml",
    "code-square": "square-code",
    columns: "columns-2",
    "columns-settings": "columns-3-cog",
    "contact-2": "contact-round",
    "curly-braces": "braces",
    "divide-circle": "circle-divide",
    "divide-square": "square-divide",
    "dot-square": "square-dot",
    "download-cloud": "cloud-download",
    edit: "square-pen",
    "edit-2": "pen",
    "edit-3": "pen-line",
    "equal-square": "square-equal",
    "file-audio": "file-headphone",
    "file-audio-2": "file-headphone",
    "file-axis-3-d": "file-axis-3d",
    "file-badge-2": "file-badge",
    "file-bar-chart": "file-chart-column-increasing",
    "file-bar-chart-2": "file-chart-column",
    "file-check-2": "file-check-corner",
    "file-code-2": "file-code-corner",
    "file-cog-2": "file-cog",
    "file-edit": "file-pen",
    "file-json": "file-braces",
    "file-json-2": "file-braces-corner",
    "file-key-2": "file-key",
    "file-line-chart": "file-chart-line",
    "file-lock-2": "file-lock",
    "file-minus-2": "file-minus-corner",
    "file-pie-chart": "file-chart-pie",
    "file-plus-2": "file-plus-corner",
    "file-question": "file-question-mark",
    "file-search-2": "file-search-corner",
    "file-signature": "file-pen-line",
    "file-type-2": "file-type-corner",
    "file-video": "file-play",
    "file-video-2": "file-video-camera",
    "file-volume-2": "file-signal",
    "file-warning": "file-exclamation-point",
    "file-x-2": "file-x-corner",
    filter: "funnel",
    "filter-x": "funnel-x",
    "flip-horizontal": "square-centerline-dashed-horizontal",
    "flip-vertical": "square-centerline-dashed-vertical",
    "folder-cog-2": "folder-cog",
    "folder-edit": "folder-pen",
    "fork-knife": "utensils",
    "fork-knife-crossed": "utensils-crossed",
    "form-input": "rectangle-ellipsis",
    frown: "face-slightly-frowning",
    "function-square": "square-function",
    "gantt-chart": "chart-no-axes-gantt",
    "gantt-chart-square": "square-chart-gantt",
    "gauge-circle": "circle-gauge",
    "git-commit": "git-commit-horizontal",
    "globe-2": "earth",
    grab: "hand-grab",
    grid: "grid-3x3",
    "grid-2-x-2": "grid-2x2",
    "grid-2-x-2-check": "grid-2x2-check",
    "grid-2-x-2-plus": "grid-2x2-plus",
    "grid-2-x-2-x": "grid-2x2-x",
    "grid-3-x-3": "grid-3x3",
    "help-circle": "circle-question-mark",
    "helping-hand": "hand-helping",
    history: "rotate-ccw-clock",
    home: "house",
    "ice-cream": "ice-cream-cone",
    "ice-cream-2": "ice-cream-bowl",
    indent: "list-indent-increase",
    "indent-decrease": "list-indent-decrease",
    "indent-increase": "list-indent-increase",
    inspect: "square-mouse-pointer",
    "kanban-square": "square-kanban",
    "kanban-square-dashed": "square-dashed-kanban",
    "laptop-2": "laptop-minimal",
    laugh: "face-grinning",
    "layers-3": "layers",
    layout: "panels-top-left",
    "letter-text": "text-initial",
    "library-square": "square-library",
    "line-chart": "chart-line",
    "loader-2": "loader-circle",
    "location-edit": "map-pin-pen",
    "m-square": "square-m",
    "mail-question": "mail-question-mark",
    meh: "face-neutral",
    "menu-square": "square-menu",
    "message-circle-question": "message-circle-question-mark",
    "mic-2": "mic-vocal",
    "minus-circle": "circle-minus",
    "minus-square": "square-minus",
    "more-horizontal": "ellipsis",
    "more-vertical": "ellipsis-vertical",
    "mouse-pointer-square-dashed": "square-dashed-mouse-pointer",
    "move-3-d": "move-3d",
    outdent: "list-indent-decrease",
    "paintbrush-2": "paintbrush-vertical",
    palmtree: "tree-palm",
    "panel-bottom-inactive": "panel-bottom-dashed",
    "panel-left-inactive": "panel-left-dashed",
    "panel-right-inactive": "panel-right-dashed",
    "panel-top-inactive": "panel-top-dashed",
    "panels-left-right": "columns-3",
    "panels-top-bottom": "rows-3",
    "parking-circle": "circle-parking",
    "parking-circle-off": "circle-parking-off",
    "parking-square": "square-parking",
    "parking-square-off": "square-parking-off",
    "pause-circle": "circle-pause",
    "pause-octagon": "octagon-pause",
    "pen-box": "square-pen",
    "pen-square": "square-pen",
    "percent-circle": "circle-percent",
    "percent-diamond": "diamond-percent",
    "percent-square": "square-percent",
    "pi-square": "square-pi",
    "pie-chart": "chart-pie",
    "pilcrow-square": "square-pilcrow",
    "play-circle": "circle-play",
    "play-square": "square-play",
    "plug-zap-2": "plug-zap",
    "plus-circle": "circle-plus",
    "plus-square": "square-plus",
    podcast: "mic-signal",
    "power-circle": "circle-power",
    "power-square": "square-power",
    "rotate-3-d": "rotate-3d",
    rows: "rows-2",
    "scale-3-d": "scale-3d",
    "scatter-chart": "chart-scatter",
    "school-2": "university",
    "scissors-square": "square-scissors",
    "scissors-square-dashed-bottom": "square-bottom-dashed-scissors",
    "send-horizonal": "send-horizontal",
    "shield-close": "shield-x",
    "shield-question": "shield-question-mark",
    sidebar: "panel-left",
    "sidebar-close": "panel-left-close",
    "sidebar-open": "panel-left-open",
    "sigma-square": "square-sigma",
    "slash-square": "square-slash",
    sliders: "sliders-vertical",
    smile: "face-slightly-smiling",
    "smile-plus": "face-slightly-smiling-plus",
    "sort-asc": "arrow-up-narrow-wide",
    "sort-desc": "arrow-down-wide-narrow",
    "split-square-horizontal": "square-split-horizontal",
    "split-square-vertical": "square-split-vertical",
    "square-gantt-chart": "square-chart-gantt",
    stars: "sparkles",
    "stop-circle": "circle-stop",
    subtitles: "captions",
    "table-config": "columns-3-cog",
    "terminal-square": "square-terminal",
    "test-tube-2": "test-tube-diagonal",
    text: "text-align-start",
    "text-select": "square-dashed-text",
    "text-selection": "square-dashed-text",
    train: "tram-front",
    "trash-2": "trash",
    "tv-2": "tv-minimal",
    unlock: "lock-open",
    "unlock-keyhole": "lock-keyhole-open",
    "upload-cloud": "cloud-upload",
    "user-2": "user-round",
    "user-check-2": "user-round-check",
    "user-circle": "circle-user",
    "user-circle-2": "circle-user-round",
    "user-cog-2": "user-round-cog",
    "user-minus-2": "user-round-minus",
    "user-plus-2": "user-round-plus",
    "user-square": "square-user",
    "user-square-2": "square-user-round",
    "user-x-2": "user-round-x",
    "users-2": "users-round",
    verified: "badge-check",
    "wallet-2": "wallet-minimal",
    "wand-2": "wand-sparkles",
    waves: "waves-horizontal",
    "wrap-text": "text-wrap",
    "x-circle": "circle-x",
    "x-octagon": "octagon-x",
    "x-square": "square-x",
};
